// @flow
import React, { Component } from 'react';
import type { NavigationRoute, NavigationScreenProp } from '@react-navigation/compat';
import { Image, Platform, StyleSheet, View } from 'react-native';
import { BulletPoint, Link, Text } from 'trpc-react-native-ui';
import { FullButton, GradientPage, Icon, Modal } from '../../../components/common';
import PageTitle from '../../../components/signUp/PageTitle';
import I18n from '../../../lib/i18n';
import theme from '../../../theme-config';
import formatMrzResults from '../../../lib/MrzResultsFormatter';
import config from '../../../config';
import { CommonActions } from '@react-navigation/native';
import Navigation from '../../../lib/navigation';

class IdentityRequirements extends Component<Props, State> {
  state = {
    isModalOpen: false,
  };
  styles = getStyles();

  // This function allow us to avoid going back to createAccount which leads to an error
  // if the user resubmit his credentials because the account is already created
  handlePopState = () => {
    const routes = this.props.navigation.getState().routes;
    if (routes[routes.length - 1].name !== 'createAccount') return;
    Navigation.dispatch(CommonActions.navigate({ name: 'chooseNumber' }));
    window.removeEventListener('popstate', this.handlePopState);
  };

  componentDidMount() {
    Platform.OS === 'web' && window.addEventListener('popstate', this.handlePopState);
  }

  skipPassportCheckCheatCode = () => {
    const randomDocumentNumber = Math.floor(Math.random() * 1000);

    this.props.storePassportInfo(
      formatMrzResults(
        //$FlowFixMe
        {
          fields: {
            administrativeCode: '132000',
            administrativeCode2: '199',
            birthDate: '950417',
            birthDateCheckDigit: '0',
            compositeCheckDigit: '',
            documentCode: 'ID',
            documentNumber: String(randomDocumentNumber),
            documentNumberCheckDigit: '',
            firstName: 'Laurent  LUCAS',
            issueDate: '0903',
            issuingState: 'FRA',
            lastName: 'Jajus',
            sex: 'male',
          },
          format: 'FRENCH_NATIONAL_ID',
        },
        'base64image'
      )
    );

    this.props.goToConfirmPersonalInfo();
  };

  openModal = () => this.setState({ isModalOpen: true });
  closeModal = () => this.setState({ isModalOpen: false });

  modalExplanations = [
    I18n.t('SignUp.IdentityRequirements.explanationText1'),
    I18n.t('SignUp.IdentityRequirements.explanationText2'),
    I18n.t('SignUp.IdentityRequirements.explanationText3'),
  ];

  render() {
    const styles = this.styles;
    return (
      <GradientPage iosEdges={['top','bottom']} maxWidth={600}>
        <View style={styles.pageContainer}>
          <PageTitle title={I18n.t('SignUp.IdentityRequirements.title')} />
          <View style={styles.contentContainer}>
            {theme.identityCardImage ? (
              <Image style={styles.image} source={theme.identityCardImage} />
            ) : (
              <Icon name="selfie-identitycard" size={129} color={theme.signUpTextColor} />
            )}
          </View>
          <View style={styles.requirementContainer}>
            <Text style={styles.requirement}>{I18n.t('SignUp.IdentityRequirements.prepareYourId')}</Text>
            <Text style={styles.requirement}>{I18n.t('SignUp.IdentityRequirements.compareIdAndSelfie')}</Text>
            {this.props.displayIdentityRequirementLink && (
              <Link
                text={I18n.t('SignUp.IdentityRequirements.whyPerformThisStep')}
                style={styles.link}
                onPress={this.openModal}
              />
            )}
          </View>
          <FullButton
            text={I18n.t('SignUp.IdentityRequirements.registerCard')}
            onPress={this.props.goToPassportCheck}
            onLongPress={config.areCheatCodesEnabled || __DEV__ ? this.skipPassportCheckCheatCode : undefined}
            testID={'identityCheckButton'}
            style={styles.button}
          />
          <Modal visible={this.state.isModalOpen} requestClose={this.closeModal} fullScreen>
            <Text style={styles.modalTitle}>{I18n.t('SignUp.IdentityRequirements.whyIsIDAndFaceRequired')}</Text>
            {this.modalExplanations.map((expanationText, index) => (
              <BulletPoint
                key={index}
                text={expanationText}
                containerStyle={styles.bulletPointContainerStyle}
                bulletPointStyle={styles.bulletPointStyle}
                textStyle={styles.bulletPointTextStyle}
              />
            ))}
          </Modal>
        </View>
      </GradientPage>
    );
  }
}

function getStyles() {
  return StyleSheet.create({
    pageContainer: {
      flex: 1,
      justifyContent: 'space-around',
      marginHorizontal: 22,
      backgroundColor: 'transparent',
    },
    contentContainer: {
      alignItems: 'center',
      paddingTop: 15,
    },
    button: {
      marginBottom: 30,
    },
    requirementContainer: {
      marginBottom: 25,
    },
    requirement: {
      fontSize: 16,
      marginTop: 20,
      textAlign: 'center',
    },
    image: {
      height: 100,
      width: 100,
      resizeMode: 'contain',
    },
    link: {
      color: theme.signUpTextColor,
      textDecorationLine: 'underline',
      fontSize: 18,
      textAlign: 'center',
      marginTop: 20,
    },
    modalTitle: {
      color: theme.signUpTextColor,
      alignSelf: 'center',
      textAlign: 'center',
      marginVertical: 20,
      fontSize: 18,
    },
    bulletPointContainerStyle: {
      alignItems: 'flex-start',
      paddingRight: 20,
      paddingLeft: 5,
      marginTop: 10,
    },
    bulletPointStyle: {
      color: theme.signUpDarkTextColor,
      marginTop: 5,
      fontSize: 12,
    },
    bulletPointTextStyle: {
      fontSize: 14,
    },
  });
}

type Props = {
  navigation: NavigationScreenProp<NavigationRoute>,
  storePassportInfo: Function,
  goToConfirmPersonalInfo: Function,
  goToPassportCheck: Function,
  displayIdentityRequirementLink: boolean,
};

type State = {
  isModalOpen: boolean,
};

export default IdentityRequirements;
